import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, ArrowRight, Sparkles } from "lucide-react";
import { getTenantGallery } from "@/lib/api";

export default function KeralaGallery() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    document.title = "Kerala.com · AI Redesign Gallery";
    getTenantGallery("kerala").then((d) => setItems(d.items || [])).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="kerala-gallery">
      <section className="bg-gradient-to-br from-[#024E3F] to-[#012a22] text-white py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-wider text-emerald-300">AI Redesign Gallery</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold mt-2">Kerala businesses, reimagined with AI</h1>
          <p className="text-emerald-100/80 mt-4 md:text-lg max-w-2xl">Real-world style showcases — see how we transform resorts, clinics and exporters into high-converting websites. Get the full concept as a PDF.</p>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {items === null ? (
            <div className="flex justify-center py-20"><Loader2 className="animate-spin text-emerald-700" size={26} /></div>
          ) : items.length === 0 ? (
            <p className="text-center text-slate-500">Showcases coming soon. <Link to="/kerala/contact" className="text-emerald-700 font-semibold">Talk to us</Link>.</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((c, i) => (
                <motion.div key={c.id} initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: (i % 3) * 0.06 }}
                  className="group bg-white border border-slate-200 rounded-2xl overflow-hidden card-shadow hover:-translate-y-1 transition-transform" data-testid="kerala-gallery-card">
                  <div className="h-40 flex" data-no-translate>
                    {(c.palette || []).slice(0, 5).map((p, idx) => (
                      <div key={idx} className="flex-1" style={{ background: p.hex }} />
                    ))}
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-2 text-xs text-emerald-700 font-semibold uppercase tracking-wide mb-2"><Sparkles size={13} /> Concept</div>
                    <h3 className="font-heading text-lg font-bold text-slate-900 leading-snug">{c.headline}</h3>
                    <p className="text-sm text-slate-500 mt-1.5 line-clamp-2">{c.subheadline}</p>
                    <p className="text-xs text-slate-400 mt-3">{c.domain} · Score before: {c.overall_score}/100</p>
                    <Link to={`/preview/${c.id}`} data-testid="kerala-gallery-view"
                      className="mt-4 inline-flex items-center gap-1.5 text-emerald-700 font-semibold text-sm group-hover:gap-2.5 transition-all">
                      View concept & get PDF <ArrowRight size={15} />
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
          <div className="text-center mt-14">
            <p className="text-slate-500">Want this for your business?</p>
            <Link to="/kerala/audit" className="mt-4 inline-flex items-center gap-2 bg-emerald-700 text-white font-semibold rounded-xl px-7 py-3.5 hover:-translate-y-0.5 transition-transform">Get my free audit <ArrowRight size={17} /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
